import moment from "moment";
import ConfirmationModal from "../../../components/ConfirmationModal";
import AdminInputDatePicker from "../../../components/AdminInputDatePicker";
import { CalendarAltIcon } from "../../../../icons/index";

// Asks for the dates when an admin re-activates an expired quotation: the
// quotation is re-issued, so both the issue date and the expiry date are set here.
// The expiry date must be in the future — the daily expiry job expires anything
// valid up to today, so "today" would expire again the same night.
const ActivateQuotationModal = ({
  show,
  quotationID,
  issueDate,
  expiryDate,
  onSelectIssueDate,
  onSelectExpiryDate,
  onClose,
  onActivate,
  isActivating = false,
  error = "",
}) => {
  const tomorrow = moment().add(1, "day").startOf("day").toDate();

  // A quotation can never expire before it was issued, so the issue-date picker
  // stops at the chosen expiry date.
  const toDate = (value) => (value ? moment(value, "YYYY-MM-DD").toDate() : null);
  const latestAllowedIssueDate = toDate(expiryDate);

  return (
    <ConfirmationModal
      show={show}
      title={`Reactivate quotation ${quotationID || ""}?`}
      description="Pick a new issue date and expiry date. The quotation becomes active again and its link works for the customer until the expiry date."
      variant="primary"
      confirmLabel="Reactivate"
      busyLabel="Reactivating…"
      isBusy={isActivating}
      error={error}
      onCancel={onClose}
      onConfirm={onActivate}
    >
      <label className="mb-2 fs-14">Issue Date</label>
      <AdminInputDatePicker
        placeholder="Select Issue Date"
        prefixIcon={<CalendarAltIcon />}
        onSelectDate={onSelectIssueDate}
        name="issueDate"
        value={toDate(issueDate)}
        maxDate={latestAllowedIssueDate}
        dateFormat="MMMM d, yyyy"
        disable={isActivating}
      />

      <label className="mb-2 fs-14">Expiry Date</label>
      <AdminInputDatePicker
        placeholder="Select Expiry Date"
        prefixIcon={<CalendarAltIcon />}
        onSelectDate={onSelectExpiryDate}
        mb=""
        name="expiredDate"
        value={toDate(expiryDate)}
        minDate={tomorrow}
        dateFormat="MMMM d, yyyy"
        disable={isActivating}
      />
    </ConfirmationModal>
  );
};

export default ActivateQuotationModal;
